export default "__VITE_ASSET__DCgNoJiy__"